import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  modal: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
  actions: { display: 'flex', justifyContent: 'space-between', gap: '1rem', marginTop: '1rem' },
  button: {
    backgroundColor: '#159B78',
    color: 'white'
  },
  buttonDiscart: {
    outline: '1px solid #be1224 !important',
    color: '#be1224'
  },
  loadingCircular: {
    position: 'absolute',
    left: '48%'
  }
}));
